import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { DownloadButton } from '@/components/buttons';
import { DocumentSection } from '@/sections/documents/DocumentSection';
import { FILES } from '@/constants/files';
export function CareerMemorandum() {
  const $ = _c(21);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["personalData"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  let t1;
  if ($[1] !== t) {
    t1 = t("categories.3.title");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t) {
    t2 = t("categories.3.text");
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t2) {
    t3 = <p className="mb-8">{t2}</p>;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t) {
    t4 = t("categories.3.documents.title");
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t4) {
    t5 = <h3 className="mb-6 text-base font-bold lg:text-2xl">{t4}</h3>;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = FILES();
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const t7 = t6.informationMemorandumCareer;
  let t8;
  if ($[12] !== t) {
    t8 = t("categories.3.documents.careerMemorandum");
    $[12] = t;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t8) {
    t9 = <div className="inline-block"><div className="mb-2 lg:mb-4"><DownloadButton to={t7} testId="informationMemorandumCareer" analyticsParam="informationMemorandumCareer" className="sm:w-full">{t8}</DownloadButton></div></div>;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t1 || $[17] !== t3 || $[18] !== t5 || $[19] !== t9) {
    t10 = <DocumentSection title={t1} isDropdown={false} id="careerMemorandum">{t3}{t5}{t9}</DocumentSection>;
    $[16] = t1;
    $[17] = t3;
    $[18] = t5;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  return t10;
}